/**
 * Šířka levého labelu (inline layout) sdílená formuláři projektu a produktu ve Venua Planneru —
 * drží svislé zarovnání labelů napříč poli i panely.
 */
export const FORM_LABEL_WIDTH = 172;
